import req from "../http";

const api = {
  // 取得 面談室列表
  getRoomList() {
    return req("get", "/InterviewSch/Room");
  },

  // 新增 面談室
  createRoom(params) {
    return req("post", "/InterviewSch/Room", params);
  },

  
  // 刪除 面談室
  deleteRoom(id) {
    return req("delete", `/InterviewSch/Room/${id}`);
  },

  // 更新 面談室 
  editRoom(params) {
    return req("put", `/InterviewSch/Room/${params.Guid}`, params);
  },

  // 取得 面談室詳細資訊
  getRoomDetail(id) {
    return req("put", `/InterviewSch/Room/${id}`);
  },


  //---------------------------面談流程維護
  // 取得 基本流程列表
  getFlowSource(params) {
    return req("get", "/InterviewSch/FlowSource",params);
  },
  // 新增 基本流程
  createFlowSource(params) {
    return req("post", "/InterviewSch/FlowSource",params);
  },
  // 維護 基本流程
  editFlowSource(params) {
    return req("put", `/InterviewSch/FlowSource/${params.Guid}`,params);
  },
  
  // 刪除 基本流程
  deleteFlowSource(id) {
    return req("delete", `/InterviewSch/FlowSource/${id}`);
  },


  //---------------------------面談階段維護  
  // 取得 階段列表
  getStage() {
    return req("get", "/InterviewSch/Stage");
  },
  // 新增 階段
  createStage(params) {
    return req("post", "/InterviewSch/Stage",params);
  },
  // 編輯 階段
  editStage(params) {
    return req("put", `/InterviewSch/Stage/${params.Guid}`,params);
  },
  // 編輯 階段
  deleteStage(id) {
    return req("delete", `/InterviewSch/Stage/${id}`);
  },
  // 取得 階段類型
  getStageType() {
    return req("get", `/InterviewSch/Stage/Options/Type`);
  },

  //--------------------------面談參數維護
  // 取得 參數設定主畫面
  getConfig(params) {
    return req("get", "/InterviewSch/Config",params);
  },
  // 批次 儲存參數設定
  editConfig(params) {
    return req("put", "/InterviewSch/Config",params);
  },

  
  //--------------------------面談報到
  // 取得 報到頁面面談者列表
  getCheckIn(params) {
    return req("get", "/InterviewSch/CheckIn",params);
  },
  // 對目標面談安排進行報到
  checkInArrange(id) {
    return req("post", `/InterviewSch/CheckIn/${id}`);
  },
  // 取得 基本流程選項
  getFlowOptions() {    
    return req("get", `/InterviewSch/CheckIn/Options/Flow`);
  },
  // 取得 接待窗口選項
  getContactOptions() {    
    return req("get", `/InterviewSch/CheckIn/Options/Contact`);
  },
  // 取得 時段選項
  getTimePeriodOptions() {    
    return req("get", `/InterviewSch/CheckIn/Options/TimePeriod`);
  },
  // 設定目標面談安排資料的面談流程
  setFlow(params) {        
    return req("put", `/InterviewSch/CheckIn/Flow/${params.arrangeGuid}/${params.baseFlowGuid}`);
  },
  // 設定目標面談安排資料的接待窗口
  setContact(params) {            
    return req("put", `/InterviewSch/CheckIn/Contact/${params.arrangeGuid}/${params.contactPersonGuid}`);
  },
  // 設定目標面談安排資料的HR主管(InterviewRecord)
  setHrSupervisor(params) {          
    return req("put", `/InterviewSch/CheckIn/HrSupervisor/${params.arrangeGuid}/${params.contactPersonGuid}`);
  },
  // 設定目標面談安排資料的接待窗口
  setManagerSupervisor(params) {            
    return req("put", `/InterviewSch/CheckIn/ManagerSupervisor/${params.arrangeGuid}/${params.contactPersonGuid}`);
  },
  // 改期目標面談安排
  reArrange(arrangeGuid,params) {            
    return req("post", `/InterviewSch/CheckIn/ReArrange/${arrangeGuid}`,params);
  },
  // 取消目標面談安排
  cancelInterview(arrangeGuid,params) {            
    return req("post", `/InterviewSch/CheckIn/Cancel/${arrangeGuid}`,params);
  },
  // 取得臨時到廠所需外部站台網址
  getExternalUrl() {        
    return req("get", `/BasicInformation/GetExternalUrl`,);
  },

  //取得 取消報到的罐頭選項  
  getCancelOptions() {        
    return req("get", `/InterviewSch/CheckIn/Options/SchCancelCategories`,);
  },

  //取得 改期的罐頭選項  
  getReArrangeOptions() {        
    return req("get", `/InterviewSch/CheckIn/Options/SchReArrange`,);
  },

  
  //--------------------------面談報到
  
  // 取得 面談流程總覽資料
  getFlowOverview(params) {    
    return req("get", `/InterviewSch/FlowOverview`,params);
  },
  // 取得 報到情形搜尋條件選項
  getCheckInStatus() {       
    return req("get", `/InterviewSch/FlowOverview/Options/CheckInStatus `);
  },
  // 取得 面試狀態搜尋條件選項
  getInterviewStatus() {           
    return req("get", `/InterviewSch/FlowOverview/Options/InterviewStatus `);
  },
  // 取得 應徵職務搜尋條件選項
  getPosition() {               
    return req("get", `/InterviewSch/FlowOverview/Options/ManpowerDemand `);
  },
  // 設定目標面談安排資料的面談流程
  setOverviewFlow(params) {        
    return req("put", `/InterviewSch/FlowOverview/Flow/${params.arrangeGuid}/${params.baseFlowGuid}`);
  },
  // 設定目標面談安排資料的接待窗口
  setOverviewContact(params) {              
    return req("put", `/InterviewSch/FlowOverview/Contact/${params.arrangeGuid}/${params.contactPersonGuid}`);
  },
  // 新增臨時到廠
  addArrangeTemporary(params) {           
    return req("post", `/InterviewSch/CheckIn/AddArrangeTemporary`,params);
  },

  //臨時到廠批次轉入職缺
  matchJobManagement(params) {          
    return req("post", `/InterviewSch/CheckIn/MatchJobManagement`,params);
  },
  
  //--------------------------面談室安排
  // 取得 面談室安排主畫面拖移資料
  getAssignRoom() {    
    return req("get", `/InterviewSch/AssignRoom`);
  },  
  // 面談室啟用/停用
  changeRoomStatus(params) {        
    return req("post", `/InterviewSch/AssignRoom/Room/${params.roomGuid}/${params.isEnable}`);
  },  
  // 開始該面談室的面談階段
  roomStart(id,stageGuid) {        
    return req("post", `/InterviewSch/AssignRoom/Start/${id}/${stageGuid}`);
  },
  // 結束該面談室的面談階段
  roomEnd(id,stageGuid) {        
    return req("post", `/InterviewSch/AssignRoom/End/${id}/${stageGuid}`);
  },
  // 清除所有報到時間非今日的隔日面談室占用者的占用狀態
  clearAssignRoom() {        
    return req("delete", `/InterviewSch/AssignRoom/Clear`);
  },
  
  // 將目標人員安排進指定面談室
  assignRoom(params) { 
    if(params.RoomGuid){
      return req("put", `/InterviewSch/AssignRoom/${params.Guid}/${params.RoomGuid}`);
    }else{
      return req("put", `/InterviewSch/AssignRoom/${params.Guid}/`);
    }
    
  },
  //--------------------------面談流程管理
  // 取得 面談流程管理主畫面資料清單
  getFlowManage(params) {    
    return req("get", `/InterviewSch/FlowManage`,params);
  },  
  // 取得 面談人員選項
  getSupervisor() {    
    return req("get", `/InterviewSch/FlowManage/Options/Supervisor`);
  },  
  // 設置 目標階段的 面試/HR主管
  setSupervisor(params) {        
    return req("put", `/InterviewSch/FlowManage/Supervisor`,params);
  },  


  // 開始本階段
  startArrange(id,stageGuid) {    
    return req("post", `/InterviewSch/FlowManage/Start/${id}/${stageGuid}`);
  },  
  // 結束本階段
  endArrange(id,stageGuid) {    
    return req("post", `/InterviewSch/FlowManage/End/${id}/${stageGuid}`);
  },  
  // 取消本階段
  cancelArrange(id,stageGuid) {        
    return req("post", `/InterviewSch/FlowManage/Cancel/${id}/${stageGuid}`);
  },  

  // 跳過目標階段
  passArrange(params) {        
    return req("post", `/InterviewSch/FlowManage/Pass/${params.arrangeGuid}/${params.stageGuid}`);
  },  

  
  // 結案本面談
  finishArrange(params) {          
    return req("post", `/InterviewSch/FlowManage/Finish/${params.arrangeGuid}`,params);
  },  

  
  
  // 轉推薦
  transferArrange(params) {          
    return req("post", `/InterviewSch/FlowManage/MatchJobManagement/${params.arrangeGuid}`,params);
  },  

  
  // 移動階段至指定位置
  moveArrange(params) {          
    return req("post", `/InterviewSch/FlowManage/Move`,params);
  },  
  
  // 取得強制結案的罐頭訊息結案原因選項
  getCancelReason() {        
    return req("get", `/InterviewSch/FlowManage/Options/CancelReason`);
  },  

  // 取得可插入階段
  getInsertStage(arrangeGuid) { 
    return req("get", `/InterviewSch/FlowManage/Options/InsertStage/${arrangeGuid}`);
  },  
  // 插入階段至尾部
  insertStage(params) {     
    return req("post", `/InterviewSch/FlowManage/Insert/${params.arrangeGuid}/${params.stageGuid}`);
  },  
  //--------------------------滿意度調查表
  // 取得滿意度問卷結果
  getFeedbackResult(params) {     
    return req("get", `/InterviewSch/Feedback`,params);
  },  
  // 取得滿意度問卷結果
  getFeedbackResultDetail(arrangeGuid) {     
    return req("get", `/InterviewSch/Feedback/${arrangeGuid}`);
  },
  // 取得目標滿意度問卷結果的人事回覆訊息
  getFeedbackReply(arrangeGuid) {         
    return req("get", `/InterviewSch/Feedback/Reply/${arrangeGuid}`);
  },
  // 儲存目標滿意度問卷結果的人事回覆訊息
  saveFeedbackReply(params) {         
    return req("put", `/InterviewSch/Feedback/Reply/${params.Guid}`,params);
  },
  //取得當日報到仍未填寫滿意度調查表的面談者
  getTodayCheckIn() {    
    return req("get", `/InterviewSch/Feedback/Options/TodayCheckIn`);
  },
  //驗證身份證字號並索取滿意度調查表物件  
  validatePerson(params) {    
    return req("post", `/InterviewSch/Feedback/Validate`,params);
  },
  //送出表單
  sendFeedback(params) {    
    return req("post", `/InterviewSch/Feedback/Write`,params);
  },

  
  // 下載 滿意度問卷範本
  feedbackTemplateDownload() {
    return req("get", "/InterviewSch/Feedback/Excel", null, { responseType: "blob" });
  },

  // 上傳 滿意度問卷
  uploadFeedback(params) {
    return req("post", "/InterviewSch/Feedback/Excel", params, { headers: { "Content-Type": "multipart/form-data" } });
  },

  
  //--------------------------公播設定
  //取得維護公播畫面資料
  getLobbyTV() {    
    return req("get", `/InterviewSch/LobbyTV/Setting`);
  },
  //批次儲存畫格內容
  saveLobbyTV(params) {    
    return req("put", `/InterviewSch/LobbyTV/Save`,params);
  },
  //移動畫格至排版位置
  moveLobbyTV(params) {    
    return req("post", `/InterviewSch/LobbyTV/Move`,params);
  },
  //選擇公播格式
  changeLobbyTVFormat(format) {        
    return req("post", `/InterviewSch/LobbyTV/Select/${format}`);
  },
  
  //--------------------------公播顯示
  //取得公播面談間狀態
  getRoomStatus() {    
    return req("get", `/InterviewSch/LobbyTV/RoomStatus`);
  },
  //取得公播應聘者狀態
  getIntervieweeStatus() {    
    return req("get", `/InterviewSch/LobbyTV/IntervieweeStatus`);
  },
  
  //取得公播畫面
  getShowLobbyTV() {    
    return req("get", `/InterviewSch/LobbyTV`);
  },
  //取得翻頁秒數
  getPagingSecond() {    
    return req("get", `/InterviewSch/LobbyTV/Options/PagingSecond`);
  },
  //取得公播面談間狀態
  // getVideoUrl(fileGroupGuid) {        
  //   return req("get", `/InterviewSch/LobbyTV/Video/${fileGroupGuid}`);
  // },

  
  //--------------------------報表滿意度問卷
  //取得報表滿意度問卷資料
  getFeedbackReport(params) {        
    return req("get", `/InterviewSch/Report/Feedback`,params);
  },
  //取得招募窗口選項(僅被選擇過的窗口)
  getFeedbackReportContact() {            
    return req("get", `/InterviewSch/Report/Feedback/Options/Contact`);
  },
  
  // 取得報表滿意度作答資料匯出Excel  
  exportFeedbackExcel(params) {
    return req("get", `/InterviewSch/Report/Feedback/Excel`, params,{ responseType: "blob" });
  },
  //--------------------------邏輯考試
  //取得邏輯考試維護分數介面資訊
  getLogicTest() {        
    return req("get", `/InterviewSch/LogicTest/Mnt`);
  },
  //設定邏輯考試分數與解答
  setLogicTest(params) {        
    return req("put", `/InterviewSch/LogicTest/Mnt`,params);
  },
  //取得當日報到需填分數，但仍未進行邏輯考試的面試者
  getTodayLogicTestPerson() {    
    return req("get", `/InterviewSch/LogicTest/Options/TodayCheckIn`);        
  },
  //驗證身份證字號並索取邏輯考試表單物件
  validateLogicTestPerson(params) {    
    return req("post", `/InterviewSch/LogicTest/Validate`,params);
  },
  //驗證身份證字號並填寫邏輯考試
  sendLogicTest(params) {    
    return req("post", `/InterviewSch/LogicTest/Write`,params);
  },
  //邏輯考試結果查詢
  getLogicTestResult(params) {          
    return req("get", `/InterviewSch/LogicTest`,params);
  },
  //取得應徵職務搜尋條件選項
  getLogicPosition() {    
    return req("get", `/InterviewSch/LogicTest/Options/ManpowerDemand`);
  },
  //取得應徵職務搜尋條件選項
  getLogicTestContact() {           
    return req("get", `/InterviewSch/LogicTest/Options/Contact`);
  },
  //--------------------------報表
  //取得面談流程報表資料
  getReportFlow(params) {           
    return req("get", `/InterviewSch/Report/Flow`,params);
  },
  //取得面談流程選項(包含未啟用流程)
  getReportFlowFlowOption() {           
    return req("get", `/InterviewSch/Report/Flow/Options/Flow`);
  },
  //取得招募窗口選項(僅被選擇過的窗口)
  getReportFlowContactOption() {           
    return req("get", `/InterviewSch/Report/Flow/Options/Contact`);
  },
  
  // 取得流程報表報表資料匯出Excel檔案  
  exportFlowExcel(params) {
    return req("get", `/InterviewSch/Report/Flow/Excel`, params,{ responseType: "blob" });
  },

};

export default api;